import { Component, computed, inject, OnDestroy, OnInit, signal, viewChild } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTabChangeEvent, MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { CompanyComponent } from './company/company.component';
import { FeesComponent } from './fees/fees.component';
import { BrandingComponent } from './branding/branding.component';
import { AdminUsersComponent } from './admin-users/admin-users.component';

enum AdminTabs {
  company = 0,
  fees = 1,
  branding = 2,
  adminusers = 3
};

@Component({
  selector: 'lib-admin-settings',
  templateUrl: './admin-settings.component.html',
  styleUrl: './admin-settings.component.scss',
  imports: [
    MatTabsModule,
    CompanyComponent,
    FeesComponent,
    BrandingComponent,
    AdminUsersComponent
],
})
export class AdminSettingsComponent implements OnInit {
  tabGroup = viewChild<MatTabGroup>('tabGroup');
  tab: string | null = null;
  baseUrl = 'wholesale-settings';
  tenantId = '';

  constructor(
    private route: ActivatedRoute,
    private location: Location
  ) {
    this.tenantId = this.route.snapshot.queryParams['tenantId'] || '';
  }

  ngOnInit(): void {
    this.tab = this.route.snapshot.paramMap.get('tab');
    if (!this.tab) {
      this.tab = 'company';
      const newUrl = `${this.baseUrl}/company?tenantId=${this.tenantId}`;
      this.location.go(newUrl);
    }
    this.navToNewTab(this.tab as keyof typeof AdminTabs);
  }

  navToNewTab(tab: keyof typeof AdminTabs): void {
    const tabGroup = this.tabGroup();
    if (!tabGroup) {
      return;
    }
    tabGroup.selectedIndex = AdminTabs[tab as keyof typeof AdminTabs];
  }

  onTabChange(event: MatTabChangeEvent): void {
    const newTab = AdminTabs[event.index];
    const newUrl = `${this.baseUrl}/${newTab}?tenantId=${this.tenantId}`;
    this.location.go(newUrl);
  }
}